import { type FC } from 'react';
import { useUnit } from 'effector-react';
import { useNavigate } from 'react-router';
import { Button, Group, Stack } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { createPayoutCascadeGroupUrl, type PayoutGroup } from '~/entities/payout';
import { CascadeGroupsFilter } from './components/CascadeGroupsFilter';
import { CascadeGroupsList } from './components/CascadeGroupsList';
import { $cascadeGroupsFilter, paginationModel } from './model';

export const CascadeGroups: FC = () => {
    const filter = useUnit($cascadeGroupsFilter);
    const navigate = useNavigate();

    const handleRowClick = (group: PayoutGroup) => {
        if (group.id?.value) {
            navigate(createPayoutCascadeGroupUrl(group.id.value));
        }
    };

    return (
        <Stack gap='sm'>
            <Group justify='space-between'>
                <CascadeGroupsFilter />

                <Button
                    leftSection={<IconPlus size={16} />}
                    onClick={() => navigate(createPayoutCascadeGroupUrl())}
                >
                    Создать группу
                </Button>
            </Group>

            <CascadeGroupsList
                filter={filter}
                paginationModel={paginationModel}
                onClick={handleRowClick}
            />
        </Stack>
    );
};
